import { buildApiUrl, fetchJSON, validateRequiredParams } from '../crm/crmApi';

export type InvestorActivityType =
  | 'intro_call'
  | 'pitch'
  | 'diligence'
  | 'update'
  | 'email'
  | 'meeting'
  | 'note'
  | 'other';

export interface InvestorActivityInput {
  organization_id: string;
  investor_id: string;
  activity_type?: InvestorActivityType;
  summary: string;
  outcome?: string;
  next_step?: string;
  occurred_at?: string;
}

export interface InvestorActivity extends InvestorActivityInput {
  id: string;
  created_by: string;
  created_at: string;
}

export interface ListInvestorActivitiesParams {
  organization_id: string;
  investor_id: string;
  limit?: number;
  offset?: number;
}

const activitiesService = {
  async list(params: ListInvestorActivitiesParams): Promise<{ data: InvestorActivity[]; count: number | null }>{
    validateRequiredParams(params, ['organization_id', 'investor_id'], {
      service: 'investorCrm.activitiesService.list'
    });
    const url = buildApiUrl(`/api/investor-crm/investors/${encodeURIComponent(params.investor_id)}/activities`, params as any);
    return fetchJSON(url, {
      description: 'List investor CRM activities',
      context: {
        organization_id: params.organization_id,
        investor_id: params.investor_id,
        limit: params.limit,
        offset: params.offset
      }
    });
  },
  async create(payload: InvestorActivityInput): Promise<{ data: InvestorActivity }>{
    validateRequiredParams(payload, ['organization_id', 'investor_id', 'summary'], {
      service: 'investorCrm.activitiesService.create'
    });
    const url = buildApiUrl(`/api/investor-crm/investors/${encodeURIComponent(payload.investor_id)}/activities`);
    return fetchJSON(url, {
      method: 'POST',
      body: payload,
      description: 'Create investor CRM activity',
      context: {
        organization_id: payload.organization_id,
        investor_id: payload.investor_id,
        activity_type: payload.activity_type
      }
    });
  }
};

export default activitiesService;
